<nz-form-item>
  <div nz-row nzJustify="space-between" class="align-items-baseline">
    <nz-form-label>{{ label }}</nz-form-label>
    <nz-radio-group [formControl]="form.controls.applyPaDiscount"
                    [nzDisabled]="isRadioDisabled()"
                    [id]="radioId"
                    [attr.data-testid]="radioId">
      <label nz-radio [nzValue]="true">{{ applyLabel }}</label>
      <label nz-radio [nzValue]="false">Spend Only</label>
    </nz-radio-group>
  </div>
  <nz-form-control>
    <nz-select
      [formControl]="form.controls.paId"
      nzAllowClear
      nzShowSearch
      [nzPlaceHolder]="placeholder"
      [id]="controlId"
      [attr.data-testid]="controlId"
      nzShowArrow="false"
      [nzOptionHeightPx]="46"
      [nzCustomTemplate]="customPadSelectedValueTpl">
      <nz-option nzCustomContent 
                 *ngFor="let option of (padAgreements | sortBy: 'agreementName')"
                 [nzLabel]="option.agreementName" 
                 [nzValue]="option.paId"
                 [nzDisabled]="isPadExpired(option)">
        <div class="display-flex flex-column"
             [title]="option.agreementName + ' (Start: ' + (option.startDate | date: 'MM/dd/yyyy') + ' | End: ' + (option.endDate | date: 'MM/dd/yyyy') + ')'">
          <div class="display-flex align-items-center">
            <span *ngIf="isPadExpired(option)" class="expired-pad-tag">EXPIRED</span>
            {{option.agreementName}}
          </div>
          <span class="font-size-smallest line-height-1 light-font margin-bottom-smallest">
            Start: {{option.startDate | date: 'MM/dd/yyyy'}} | End: {{option.endDate | date: 'MM/dd/yyyy'}}
          </span>
        </div>
      </nz-option>
    </nz-select>
    <ng-template #customPadSelectedValueTpl let-selected>
      <span *ngIf="isPadExpiredById(selected.nzValue)" class="expired-pad-tag">EXPIRED</span>
      {{selected.nzLabel}}
    </ng-template>
  </nz-form-control>
</nz-form-item>
